module.exports = __webpack_public_path__ + "static/img/icon_standard_clock.8ae0b70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/GlobalRescue/icon_standard_clock.png
// module id = LHQa
// module chunks = 1